import { UserButton } from "@clerk/clerk-react";
import { CreditCard, Receipt } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import leblanc from "../images/leblanc.png";
import { useAuth } from "../contexts/AuthContext";
import { useUsage } from "../contexts/UsageContext";
import { createPortalSession, STRIPE_ENABLED } from "../lib/api/billing";
import { appConfig } from "../config/appConfig";

function BillingPortalRedirect() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    createPortalSession()
      .then(({ portal_url }) => {
        if (!cancelled) window.location.href = portal_url;
      })
      .catch(() => {
        if (!cancelled) setError("Impossible d'ouvrir le portail de facturation.");
      });
    return () => { cancelled = true; };
  }, []);

  if (error) return <p className="p-4 text-brand-error">{error}</p>;
  return <p className="p-4 text-brand-muted">Redirection vers le portail de facturation…</p>;
}

/**
 * SearchHeader component with role-based Admin link visibility
 * Feature: 001-user-role-management (T042)
 */
export function SearchHeader() {
  const { isAdmin } = useAuth();
  const { hasSubscription, isAdminManaged } = useUsage();

  return (
    <header className="fixed inset-x-0 top-0 z-50 flex items-center justify-between p-4">
      <Link
        to="https://www.leblanc-associes.com/"
        className="flex items-center gap-2"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="text-sm font-bold text-brand-muted">Propulsé par</span>
        <img src={leblanc} alt="LeBlanc" className="h-8 w-auto" />
      </Link>
      <div className="flex items-center gap-4">
        {/* Second chat surface, hidden unless VITE_ENABLE_AGENT_CHAT=true */}
        {appConfig.agentChat.enabled && (
          <Link
            to="/agent"
            className="px-3 py-1.5 text-sm font-bold text-brand-text border border-brand-border rounded-full transition-colors hover:bg-brand-accent hover:text-white"
          >
            Assistant (bêta)
          </Link>
        )}
        {/* Only show Admin link for users with admin role - Feature: 001-user-role-management (T042) */}
        {isAdmin && (
          <Link
            to="/admin"
            className="px-3 py-1.5 text-sm font-bold text-brand-text border border-brand-border rounded-full transition-colors hover:bg-brand-accent hover:text-white"
          >
            Admin
          </Link>
        )}
        <UserButton
          appearance={{
            elements: {
              avatarBox: "h-8 w-8",
            },
          }}
        >
          <UserButton.UserProfileLink label="Forfaits" url="/pricing" labelIcon={<CreditCard size={16} />} />
          {STRIPE_ENABLED && hasSubscription && !isAdminManaged && (
            <UserButton.UserProfilePage label="Facturation" url="billing" labelIcon={<Receipt size={16} />}>
              <BillingPortalRedirect />
            </UserButton.UserProfilePage>
          )}
        </UserButton>
      </div>
    </header>
  );
}
